// MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

// Components
import { eulaText } from '../../../../constants';
import { TBooleanControllerProps } from '../types';

const AgreementDialog = ({ isEulaOpen }: TBooleanControllerProps) => {
  return (
    <Dialog
      open={isEulaOpen.value}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            backgroundColor: '#0E1720',
            color: '#FFFFFF',
          },
        }
      }}
    >
      <DialogTitle>EULA - End User License Agreement</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Typography
          variant="body2"
          component="pre"
          sx={{
            whiteSpace: 'pre-wrap',
            fontSize: '0.85rem',
            lineHeight: 1.6,
            color: '#FFFFFF',
          }}
        >
          {eulaText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={isEulaOpen.onToggle} sx={{ color: '#1DB0BF' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AgreementDialog };